import React from 'react';

const ReviewsLink = () => (
  <a
    href="/reviews/"
    className="link link-nowrap reviews_link reviews_link-masked"
  >
    <span className="reviews_link__inner">oтзывы клиентов</span>
  </a>
);

export default ReviewsLink;
